export const CLASS_NAME = 'history-row';

export const LINK_TYPES = {
  COMPANY_PERSON: 'company_person',
  TASK: 'task',
  TEMPLATE: 'template',
};

export const CATEGORIES = {
  ASSIGNMENT: 'assignment',
  COMMENT: 'comment',
  IMPORT: 'import',
  ISSUE: 'issue',
  OFFER: 'offer',
  PUSH: 'push',
  SCHEDULE: 'schedule',
  STATUS: 'status',
  TASK: 'task',
};

export const OFFER_TYPES = {
  ACCEPTED: 'offer_accepted',
  DECLINED: 'offer_declined',
  SENT: 'offer_sent',
};

